export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";